var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"title":_vm.title,"items":_vm.items}},[(_vm.user && _vm.user.perfil === 'Administrador')?_c('TimelineGestao'):_vm._e(),_c('div',{staticClass:"card-box"},[_c('ExpedienteLista')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }